import { A, useNavigate } from "@solidjs/router";
import { createSignal } from "solid-js";

import { useI18n } from "@uic/adapters/i18n";
import { UIButton, UIInput } from "@uic/domain/generics";

import { useAuthn } from "../contexts/authn-context";

import { FloatingCard } from "./floating-card";

/**
 * @returns {import('solid-js').JSX.Element} The Signin component
 */
export function Signin() {
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [error, setError] = createSignal("");

  const nav = useNavigate();
  const { passwordSignin } = useAuthn();
  const { t } = useI18n();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email() || !password()) {
      setError(t("generics.validation.allFieldsRequired"));
      return;
    }

    try {
      await passwordSignin(email(), password());
      nav("/");
    } catch (err) {
      setError(err.message || t("domain.authn.signinFailed"));
    }
  };

  return (
    <FloatingCard>
      <h1 className="tw:mb-6 tw:font-serif tw:text-wordmark-lg tw:font-bold">
        {t("slorg.statement")}
      </h1>

      <form onSubmit={handleSubmit}>
        <fieldset className="tw:mx-auto tw:d-fieldset tw:flex tw:w-xs tw:flex-col tw:gap-4 tw:text-dense ">
          <legend className="tw:d-fieldset-legend tw:text-section">
            {t("domain.authn.signin")}
          </legend>
          <UIInput
            type="email"
            label={t("generics.inputLabels.email")}
            value={email()}
            onInput={(e) => setEmail(e.target.value)}
            placeholder={t("generics.inputLabels.email")}
            required
          />

          <UIInput
            type="password"
            label={t("generics.inputLabels.password")}
            placeholder={t("generics.inputLabels.password")}
            value={password()}
            onInput={(e) => setPassword(e.target.value)}
            error={error()}
            required
          />

          <UIButton type="submit" variant="primary">
            {t("domain.authn.signin")}
          </UIButton>
        </fieldset>
      </form>

      <div className="tw:d-divider">or</div>
      <A href="/sign/up">
        <UIButton width="full" variant="accent">
          {t("domain.authn.signup")}
        </UIButton>{" "}
      </A>
    </FloatingCard>
  );
}
